module.exports = __webpack_public_path__ + "img/mt4.a5853599.jpg";